import type { RouteObject } from 'react-router';

import { BASE, NESTED_ROUTES } from 'common/src/routes/BaseRoutes';

import AdministrationPage from 'portal/src/pages/administration/AdministrationPage';

import { administrationRouteDefinitions } from './AdministrationRouteDefinitions';
import { generatePageWithTabsRoute } from './routeGenerator';

const AdministrationRoutes: RouteObject = generatePageWithTabsRoute(
  'Manage your users, data and bills',
  BASE.ADMINISTRATION,
  NESTED_ROUTES.ADMINISTRATION.FACILITIES,
  administrationRouteDefinitions,
  AdministrationPage,
);

export default AdministrationRoutes;
